import { useQuery } from "@tanstack/react-query"
import { fetchWholesalePurchaseFrequency, type WholesalePurchaseFrequencyResponse } from "../services/wholesalePurchaseFreqService";


export function useWholesalePurchaseFrequency() {
  return useQuery<WholesalePurchaseFrequencyResponse>({
    queryKey: ["wholesale-purchase-frequency"],
    queryFn: fetchWholesalePurchaseFrequency,
    staleTime: 1000 * 60 * 5,
  });
}
